<template>
    <div>
        <div class="color_box" :style="{ backgroundColor: `var(${color})` }"></div>
        <p>{{ color.replace('--', '') }}</p>
    </div>
</template>
<script>
export default {
    props: { color: {} },
};
</script>
<style lang="scss" scoped>
div {
    width: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .color_box {
        width: 100%;
        height: 80px;
        border: 1px solid #eee;
        border-radius: 6px;
    }

    p {
        margin: 0;
        padding: 0;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;;
        margin-top: 5px;
    }
}
</style>
